<template>
    <span>
        <SvgIcon
            v-if="icon === 'twitter'"
            classes="icon-twitter"
            width="24px"
            height="20px"
            icon="twitter"
        />
        <SvgIcon
            v-else-if="icon === 'facebook'"
            classes="icon-facebook"
            width="24px"
            height="24px"
            icon="facebook"
        />
        <SvgIcon
            v-else-if="icon === 'apple'"
            classes="icon-apple"
            width="20px"
            height="24px"
            icon="apple"
        />
        <SvgIcon
            v-else-if="icon === 'google'"
            classes="icon-google"
            width="24px"
            height="24px"
            icon="google"
        />
        <span v-else></span>
    </span>
</template>

<script>
import SvgIcon from "../UI/SvgIcon";
export default {
    name: "SocialIcon",
    components: { SvgIcon },
    props: ["icon"]
};
</script>
